export const GMAP_KEY = process.env.GMAP_KEY;

const base = process.env.API_URL;

export function baseUrl(url) {
    return `${base}/${url}`;
}

export function unauthApiUrl(url) {
    return `${base}/api/${url}`;
}

export function googleMapUrl() {
    return `//maps.google.com/maps/api/js?v=3.exp&key=${GMAP_KEY}&libraries=places`;
}